export const PRODUCT_FRUIT_ID = 'QaPm9Dc29N18z3UY'

export enum LANG_ISO_2 {
  'PT_BR' = 'br',
  'EN' = 'en',
  'ES' = 'es'
}
